import { HttpClient } from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// AoT requires an exported function for factories
export const i18nHttpLoaderFactory = (): TranslateHttpLoader => {
  const http = inject(HttpClient);
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
};
